import { createReducer } from 'redux-act';

import {
  SCREEN_SCHEDULING_FETCH_DATA_INIT,
  SCREEN_SCHEDULING_FETCH_DATA_SUCCESS,
  SCREEN_SCHEDULING_FETCH_DATA_FAIL,
  SCREEN_SCHEDULING_DELETE_SCHEDULING_INIT,
  SCREEN_SCHEDULING_DELETE_SCHEDULING_SUCCESS,
  SCREEN_SCHEDULING_DELETE_SCHEDULING_FAIL,
  SCREEN_SCHEDULING_CLEAR_DATA,
  SCREEN_SCHEDULING_CREATE_SCHEDULING_INIT,
  SCREEN_SCHEDULING_CREATE_SCHEDULING_SUCCESS,
  SCREEN_SCHEDULING_CREATE_SCHEDULING_FAIL,
  SCREEN_SCHEDULING_MODIFY_SCHEDULING_INIT,
  SCREEN_SCHEDULING_MODIFY_SCHEDULING_SUCCESS,
  SCREEN_SCHEDULING_MODIFY_SCHEDULING_FAIL,
  SCREEN_SCHEDULING_CLEAN_UP,
  SCREEN_SCHEDULING_CLEAR_DATA_LOGOUT,
  SET_SCREEN_SCHEDULING,
} from 'state/actions/screenScheduling';

const initialState = {
  list: [],
  scheduling: {
    _id: '',
    name: '',
    description: '',
    screenId: '',
    activeConfigIndices: [],
  },
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const screenSchedulingReducer = createReducer(
  {
    [SCREEN_SCHEDULING_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [SCREEN_SCHEDULING_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      scheduling: payload.scheduling || initialState.scheduling,
      loading: false,
      error: null,
    }),
    [SCREEN_SCHEDULING_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCREEN_SCHEDULING_DELETE_SCHEDULING_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCREEN_SCHEDULING_DELETE_SCHEDULING_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: null,
      deleted: true,
    }),
    [SCREEN_SCHEDULING_DELETE_SCHEDULING_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCREEN_SCHEDULING_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [SCREEN_SCHEDULING_CREATE_SCHEDULING_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCREEN_SCHEDULING_CREATE_SCHEDULING_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [SCREEN_SCHEDULING_CREATE_SCHEDULING_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCREEN_SCHEDULING_MODIFY_SCHEDULING_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SCREEN_SCHEDULING_MODIFY_SCHEDULING_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [SCREEN_SCHEDULING_MODIFY_SCHEDULING_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SCREEN_SCHEDULING_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [SCREEN_SCHEDULING_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [SET_SCREEN_SCHEDULING]: (state, payload) => ({
      ...state,
      scheduling: payload.data,
    }),
  },
  initialState
);
